import { Link } from "react-router-dom";

export const Footer = () => {
  return (
    <div className="bg-white border-t flex flex-col lg:flex-row w-full">
      <div className="w-full flex flex-col justifty-center items-center p-2 lg:p-12">
        <div className="px-2">
          <Link to="/campaigns">Campaigns</Link>
        </div>
        <div className="px-2">
          <Link to="/proof-templates">Proof Templates</Link>
        </div>
        <div className="px-2">
          <Link to="/organizations">Organizations</Link>
        </div>
      </div>
      <div className="w-full flex flex-col justifty-center items-center p-2 lg:p-12">
        <div className="px-2">
          <Link to="/designs">Design Templates</Link>
        </div>
        <div className="px-2">
          <Link to="/licensing">Licensing</Link>
        </div>
        <div className="px-2">
          <Link to="/stores">Stores</Link>
        </div>
        <div className="px-2">
          <Link to="/products">Products</Link>
        </div>
      </div>
      <div className="w-full flex flex-col justifty-center items-center p-2 lg:p-12">
        <div className="px-2">
          <Link to="/vendors">Vendors</Link>
        </div>
        <div className="px-2">
          <Link to="/bulk-edit">Bulk Edit</Link>
        </div>
        <div className="px-2">
          <Link to="/users">Users</Link>
        </div>
      </div>
    </div>
  );
};
